const useLogics = () => {
  const columns = [
    {
      title: "Barkod",
      key: "barkod",
      dataIndex: "barkod",
      width: 250,
      fixed: true,
    },
    {
      title: "Müşteri Sipariş Numarası",
      key: "siparis_no",
      dataIndex: "siparis_no",
      width: 250,
      fixed: true,
    },
    {
      title: "Gönderi Numarası",
      key: "teslimat_no",
      dataIndex: "teslimat_no",
      width: 250,
    },

    {
      title: "Servis Bedeli",
      key: "hizmet_bedeli",
      dataIndex: "hizmet_bedeli",
      width: 200,
    },
    {
      title: "Teslimat Bedeli",
      key: "kargo_bedeli",
      dataIndex: "kargo_bedeli",
      width: 200,
    },
    {
      title: "Ürün Bedeli",
      key: "ürün_bedeli",
      dataIndex: "ürün_bedeli",
      width: 200,
    },
    {
      title: "Çıkış Şubesi",
      key: "cikis_sube",
      dataIndex: "cikis_sube",
      width: 200,
    },
    {
      title: "Gönderi Oluşturma Tarihi",
      key: "gonderi_olusturma_tarihi",
      dataIndex: "gonderi_olusturma_tarihi",
      width: 200,
    },
    {
      title: "Gönderi Kabul Tarihi",
      key: "gonderi_kabul_tarihi",
      dataIndex: "gonderi_kabul_tarihi",
      width: 200,
    },

    {
      title: "Söz Verilen Teslim Tarihi",
      key: "svtt",
      dataIndex: "svtt",
      width: 200,
    },
    {
      title: "Teslim Tarihi",
      key: "teslim_tarihi",
      dataIndex: "teslim_tarihi",
      width: 200,
    },
    {
      title: "İade Durumu",
      key: "iadeye_donme",
      dataIndex: "iadeye_donme",
      width: 200,
    },
    {
      title: "Varış İli",
      key: "varis_il",
      dataIndex: "varis_il",
      width: 200,
    },
    {
      title: "Varış İlçesi",
      key: "varis_ilce",
      dataIndex: "varis_ilce",
      width: 200,
    },
    {
      title: "Varış Şubesi",
      key: "varis_sube",
      dataIndex: "varis_sube",
      width: 200,
    },
  ];

  const excelColumns = [
    {
      title: "Barkod",
      key: "barkod",
    },
    {
      title: "Müşteri Sipariş Numarası",
      key: "siparis_no",
    },
    {
      title: "Gönderi Numarası",
      key: "teslimat_no",
    },
    {
      title: "Servis Bedeli",
      key: "hizmet_bedeli",
    },
    {
      title: "Teslimat Bedeli",
      key: "kargo_bedeli",
    },
    {
      title: "Ürün Bedeli",
      key: "ürün_bedeli",
    },
    {
      title: "Çıkış Şubesi",
      key: "cikis_sube",
    },
    {
      title: "Gönderi Oluşturma Tarihi",
      key: "gonderi_olusturma_tarihi",
    },
    {
      title: "Gönderi Kabul Tarihi",
      key: "gonderi_kabul_tarihi",
    },
    {
      title: "Söz Verilen Teslim Tarihi",
      key: "svtt",
    },
    {
      title: "Teslim Tarihi",
      key: "teslim_tarihi",
    },
    {
      title: "İade Durumu",
      key: "iadeye_donme",
    },

    {
      title: "Varış İli",
      key: "varis_il",
    },
    {
      title: "Varış İlçesi",
      key: "varis_ilce",
    },
    {
      title: "Varış Şubesi",
      key: "varis_sube",
    },
  ];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
